module.exports = __webpack_public_path__ + "img/icon.1f19dbcf.png";